// extracted by mini-css-extract-plugin
export default {"rpt":"rightPart_rpt__hGAiD","perc":"rightPart_perc__yj2rJ","title":"rightPart_title__X81uQ","cta":"rightPart_cta__qIRAh"};